import styled from 'styled-components';

export const ResponsiveHeaderStyled = styled.div`
  text-align: ${({ isCentered }) => (isCentered ? 'center' : 'left')};
`;
